import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import PerformanceCache from './util/PerformanceCache'

export default function NadheoEmbeddedButton(props) {
  let {show, place, startTime} = props;
  const [performance, setPerformance] = useState();

  useEffect(()=>{
    PerformanceCache.retrievePerformance({"show.name": show, "place.name": place, "start.time": startTime})
      .then((performance)=> {
        setPerformance(performance);
      })
      .catch((e)=> {
        console.log(e);
      })
  }, [show, place, startTime]);

  return (
    <BookButton performance={performance}/>
  );
}

function BookButton(props) {
  const { t } = useTranslation(["booking", "common"]);
  const {performance } = props;
  if (performance === undefined) return t("common:Chargement en cours");
  console.log(JSON.stringify(performance["performance.ref"]));
  if (performance.status === "not published") return "";
  let newBookingButton = "";

  if (performance.status === "open")
    newBookingButton =
      <a href={process.env.REACT_APP_NADHEO_CLIENT
        +performance["performance.ref"]["show.name"]+"/"
        +performance["performance.ref"]["place.name"]+"/"
        +performance["performance.ref"]["start.time"]+"/"} target="_blank" rel="noreferrer">
        <button className="button bg-colors">{t("Réserver")}</button>
      </a>;
  else console.log("Button is not available: performance is "+performance.status);

  return newBookingButton;
}
